export enum RentalInsuranceType {
  RENTAL = "RENTAL",
}

export enum MonthlyRental {
  ONE = "10000",
  TWO = "15000",
  THREE = "20000",
  FOUR = "30000",
  FIVE = "40000",
}
